module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_25_E_8.1c54cc23.mp3";